import React from 'react';
import { Box, Card, CardContent, Stack } from '@mui/material';

import EventActions from './EventActions';
import PostIndicators from '../../Shared/PostIndicators';
import { Post } from '../../../../Utils/Types/Posts';

interface PostSidePrimaryActionsProps {
  post: Post;
}

function PostSidePrimaryActions({ post }: PostSidePrimaryActionsProps) {
  const attendeesCount = post.attendees_count;
  return (
    <Card>
      <CardContent>
        <Stack spacing={3} sx={{ alignItems: 'flex-start' }}>
          <EventActions post={post} />

          {attendeesCount > 0 && (
            <Box>
              <PostIndicators postContributionsStats={{ attendees_count: attendeesCount }} />
            </Box>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}

export default PostSidePrimaryActions;
